var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.image)?_c('div',{staticClass:"plugin-home-image",class:( _obj = {}, _obj[("_" + _vm.theme)] = true, _obj ),style:({ '--img-position': _vm.position })},[(_vm.title)?_c('div',{staticClass:"plugin-home-image__title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]):_vm._e(),_c('img',{attrs:{"src":_vm.getResizedUrl(_vm.image, 640),"alt":_vm.title,"srcset":_vm.srcset}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }